import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Party = () => {
    document.title = "Partiyalar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Partiyalar", value: "/cash/party", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Partiyalar</h2>
                    <p>
                        Məhsul müxtəlif tarixlərdə daxil olduqda və satış zamanı tarixə görə (pariya) satış etmək üçün nəzərdə tutulub.{" "}
                        <Link to={"/products/parameters/party"}>Partiyalı məhsul</Link>
                        <ol>
                            <li>Məhsulu axtarış xanasından axtarın və barkod oxuyucu ilə barkodu oxudun</li>
                            <li>Məhsul səbətə əlavə olunduqda açılan pəncərədə hansı partiya olduğunu seçin</li>
                            <li>Satışı tamamlayın</li>
                        </ol>
                    </p>
                    <img src="/images/cash/party.gif" alt="Partiyalar" />
                </article>
            </div>
        </div>
    );
};
